import { Component, ViewEncapsulation } from '@angular/core';

import { MessageService as PrimeMessageService } from 'primeng/api';

import { Alert } from '../../../models/alert.model';
import { MessageService } from '../../../services/message.service';
import { AlertEnum } from '../../../enumerators/messages.enum';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [ToastModule]
})
export class AlertComponent {
  alerts: Array<Alert> = [];

  timer: any;
  descripcionBase: string = "";
  finTimer: any;

  constructor(private messageService: MessageService, private primeMessageService: PrimeMessageService) {
  }

  ngOnInit() {
    this.messageService.startAlert().subscribe((alert: Alert) => {
      this.primeMessageService.clear();
        this.setAlertData(alert);
        this.primeMessageService.add({ severity: alert.class, summary: '', detail: alert.description, life: alert.timer});
    });
  }

  setAlertData(alert: Alert) {
    switch (alert.type) {
      case AlertEnum.Success:
        alert.class = "success"
        break;

      case AlertEnum.Warning:
        alert.class = "warn"
        break;

      case AlertEnum.Error:
        alert.class = "error"
        break;

      case AlertEnum.Information:
        alert.class = "info"
        break;

      default:
        break;
    }
  }

}
